import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import { Navigate, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock, faEye, faEyeSlash, faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

import UserPool from "../../utils/UserPool";
import { isUserLoggedin } from "../../utils/Common";
import config from "../../config/config.json";
import "./Signin.css";

const Signin = () => {
  const [authenticated, setauthenticated] = useState(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    const result = isUserLoggedin();
    result && result.data && setauthenticated(true);
  }, []);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    setLoginMessage("");

    signin(
      email.trim().toLowerCase(),
      password.trim(),
      function signinSuccess(role) {
        setIsLoading(false);
        navigate("/dashboard");
      },
      function signinError(err) {
        setIsLoading(false);
        if (JSON.stringify(err).includes("PasswordResetRequiredException")) {
          navigate("/newpassword");
        } else if (
          JSON.stringify(err).includes("Temporary password has expired")
        ) {
          setLoginMessage(
            "Your temporary password has expired. Click the forgot password link below to reset your password."
          );
        } else if (err.message === "User is disabled.") {
          setLoginMessage(
            "User has been disabled. Please contact your administrator."
          );
        } else if (
          JSON.stringify(err).includes("UserNotFoundException") ||
          JSON.stringify(err).includes("NotAuthorizedException") ||
          JSON.stringify(err).includes("InternalErrorException")
        ) {
          setLoginMessage("Username or password is invalid");
        } else {
          setLoginMessage(err);
        }
      },
      function singinNewPasswordRequired() {
        setIsLoading(false);
        navigate("/newpassword?email=" + email);
      }
    );
  };

  const signin = (email, password, onSuccess, onFailure, onResetPassword) => {
    let role = "";
    let authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
      ValidationData: [],
    });
    let cognitoUser = createCognitoUser(email);
    let firstName = "";
    let lastName = "";
    let userRole = "";
    
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result_token) {
        let authenticationToken = result_token.getIdToken().getJwtToken();
        cognitoUser.getUserAttributes(function (err, result) {
          if (err) {
            return;
          } else {
            for (let i = 0; i < result.length; i++) {
              if (result[i].getName() === "custom:role") {
                role = result[i].getValue();
                userRole = result[i].getValue();
              }
              if (result[i].getName() === "given_name") {
                firstName = result[i].getValue();
              }
              if (result[i].getName() === "family_name") {
                lastName = result[i].getValue();
              }
            }
            if (firstName === "MyFirstName" && lastName === "MyLastName") {
              firstName = " ";
              lastName = " ";
            }

            localStorage.setItem("userName", firstName + " " + lastName);
            localStorage.setItem("userRole", userRole);
            localStorage.setItem("email", email);
          }
          onSuccess(role);
        });
      },
      newPasswordRequired: onResetPassword,
      onFailure: onFailure,
    });
  };

  const createCognitoUser = (email) => {
    return new CognitoUser({
      Username: email,
      Pool: UserPool,
    });
  };

  if (authenticated) {
    return <Navigate replace to="/dashboard" />;
  }

  return (
    <div className="signin-container">
      {/* Internet Explorer Warning */}
      <div className="px-3 pt-4 mt-4 d-none" id="iesection">
        <h5>
          <strong>Sorry!</strong> Internet Explorer is no longer Supported. 
          Please use Chrome, Safari, Firefox or Edge browser.
        </h5>
      </div>
      
      {/* Background Image with Overlay */}
      <div className="signin-background">
        <div className="signin-overlay"></div>
      </div>

      {/* Content Wrapper */}
      <div className="signin-content">
        {/* Left Panel - Branding Info */}
        <div className="signin-info-panel">
          <div className="signin-brand-section">
            <div className="signin-logo-container">
              {/* Using inline require to avoid import issues */}
              <img
                src={require("../../asset/image/logos/trial-main-box-logo.png")}
                alt="SMi Trial Logo"
                className="signin-brand-logo"
                onError={(e) => {
                  // Fallback if logo fails to load
                  e.target.style.display = 'none';
                }}
              />
            </div>
            
            <h1 className="signin-main-title">
              SMi Trial<sup>&trade;</sup>
            </h1>
            <h2 className="signin-subtitle">
              Protocol Compliance Management
            </h2>
            
            <div className="signin-features">
              <div className="signin-feature-badge">
                <span className="signin-feature-icon">✓</span>
                <span>Real-time Protocol Tracking</span>
              </div>
              <div className="signin-feature-badge">
                <span className="signin-feature-icon">✓</span>
                <span>Comprehensive Reporting</span>
              </div>
              <div className="signin-feature-badge">
                <span className="signin-feature-icon">✓</span>
                <span>Regulatory Compliance</span>
              </div>
            </div>

            <div className="signin-learn-more">
              <a 
                href="https://www.sciencemedia.com/trial" 
                target="_blank" 
                rel="noopener noreferrer"
                className="signin-learn-more-btn"
              >
                Learn More About SMi Trial
              </a>
            </div>
          </div>

          <div className="signin-footer">
            <p>&copy; {new Date().getFullYear()} Science Media. All Rights Reserved.</p>
            <div className="signin-footer-links">
              <a href="https://sciencemedia.com/privacy" target="_blank" rel="noopener noreferrer">
                Privacy
              </a>
              <span>•</span>
              
                Terms
              
            </div>
          </div>
        </div>

        {/* Right Panel - Login Form */}
        <div className="signin-form-panel">
          <div className="signin-form-card">
            <div className="signin-form-header">
              <img
                src={require(`../../asset/image/logos/${config.site.logo}`)}
                alt="Logo"
                className="signin-site-logo"
              />
              <h2 className="signin-form-title">Welcome Back</h2>
              <p className="signin-form-subtitle">
                Sign in to access your account
              </p>
            </div>

            <form onSubmit={onSubmit} className="signin-form">
              {loginMessage && (
                <div className="signin-alert">
                  <span className="signin-alert-icon">⚠</span>
                  <p>{loginMessage}</p>
                </div>
              )}

              <div className="signin-form-group">
                <label htmlFor="emailInput" className="signin-label">
                  Email Address
                </label>
                <div className="signin-input-wrapper">
                  <FontAwesomeIcon icon={faEnvelope} className="signin-input-icon" />
                  <input
                    type="email"
                    id="emailInput"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    className="signin-input"
                    placeholder="Enter your email"
                    required
                    autoFocus
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="signin-form-group">
                <label htmlFor="passwordInput" className="signin-label">
                  Password
                </label>
                <div className="signin-input-wrapper">
                  <FontAwesomeIcon icon={faLock} className="signin-input-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    id="passwordInput"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    className="signin-input"
                    placeholder="Enter your password"
                    required
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="signin-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1}
                    disabled={isLoading}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>

              <div className="signin-form-actions">
                <a href="/password" className="signin-forgot-link">
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className={`signin-submit-btn ${isLoading ? "signin-loading" : ""}`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="signin-spinner"></span>
                    <span>Signing In...</span>
                  </>
                ) : (
                  "Sign In"
                )}
              </button>
            </form>

            <div className="signin-help-section">
              <FontAwesomeIcon icon={faCircleQuestion} />
              <span>Need help? </span>
              <a href="mailto:help@smitrial.com" className="signin-help-link">
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
